import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_legally_required_action_been_taken_assess_monitor_2'

export const dataPointDefinition = {
  retracedId: 'has_legally_required_action_been_taken_assess_monitor_2',
  name: 'Has all legally required action been taken to assess, monitor and prevent environmental exposure to chemicals and hazard',
  description:
    'Consult applicable legal requirements for relevant environmental laws and regulations preventing/ prohibiting use of chemicals as harmful or a risk to the environment. ',
  meta: {
    slcpMeta: {
      key: 'hs-che-13',
      number: 'HS-CHE-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-che-13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30060,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
